// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"wz-z","smallCardRow":"xz-z","largeCardRow":"yz-z","productSearchRow":"zz-z","curatedRow":"Az-z"};